<template>
  <v-container>
    <loading-spinner v-if="loading"> </loading-spinner>
    <template v-else>
      <v-row dense>
        <v-col cols="auto">
          <v-card-title class="px-0">
            Anonymous Feedback
          </v-card-title>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="py-0 my-auto">
          <timeframe-select
            v-model="filter"
            v-on:change="getData"
            solo
            flat
          ></timeframe-select>
        </v-col>
        <v-col class="my-auto" cols="auto">
          <v-select
            solo
            flat
            outlined
            dense
            v-model="filter.acknowledged"
            :items="items"
            item-text="name"
            item-value="id"
            hide-details
            @change="getData"
            class="min-width"
            label="Status"
          ></v-select>
        </v-col>
        <v-col class="my-auto" cols="auto">
          <v-btn block color="secondary" @click="exportFeedback">
            Export
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card class="bg--background">
            <template v-for="(category, i) in categories">
              <pulse-feedback-category
                :key="i"
                :category="category"
                v-on:dialog="showDialog"
                v-on:dialog-multiple="showDialogMultiple"
              >
              </pulse-feedback-category>
              <v-divider
                :key="i + 'divider'"
                v-if="i < categories.length - 1"
              ></v-divider>
            </template>
            <v-row
              :class="{ 'pl-2': true, 'pr-4': true }"
              v-if="categories.length == 0"
            >
              <v-col>
                <v-card-title>
                  No feedback found
                </v-card-title>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <pulse-feedback-dialog ref="feedback"></pulse-feedback-dialog>
  </v-container>
</template>

<script>
import TimeframeSelect from "@/components/reporting/TimeframeSelect";
import PulseFeedbackDialog from "@/components/pulse/PulseFeedbackDialog";
import PulseFeedbackCategory from "@/components/pulse/PulseFeedbackCategory";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "PulseFeedback",
  components: { TimeframeSelect, PulseFeedbackDialog, PulseFeedbackCategory },
  data: () => ({
    loading: false,
    filter: null,
    items: [
      { id: false, name: "Not Acknowledged" },
      { id: true, name: "Acknowledged" }
    ]
  }),
  computed: {
    categories() {
      return this._.uniq(this.feedback.map(x => x.category));
    },
    ...mapGetters({
      feedback: "pulse/feedback"
    })
  },
  created() {
    this.filter = {
      timeframeId: this.$enums.timeframes.LAST_90_DAYS,
      acknowledged: false,
      customStartDate: null,
      customEndDate: null,
      customTimezone: moment.tz.guess(true)
    };
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      Promise.all([this.$store.dispatch("pulse/getPulseFeedback", this.filter)])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading feedback."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showDialog(item) {
      this.$refs.feedback.showDialog(item, []);
    },
    showDialogMultiple(items) {
      this.$refs.feedback.showDialog({}, items);
    },
    exportFeedback() {
      this.$store.dispatch("pulse/exportFeedback", this.filter).catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while exporting."
        );
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-chip {
  width: 50px;

  ::v-deep .v-chip__content {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
